export default __webpack_public_path__ + "static/media/desk.1121ad37.svg";